import FormsPreviewPhoneTextDragComponentAds from "./FormsPreviewPhoneTextDragComponentAds";

const MobileViewTextDragComponentAds = ({
    data,
    contentDroppableAreaRender,
    fileList,
    picUrl,
    dataObject,
    AdsTab,
    activeAdSection = "splash",
    banners = [],
    popupPicUrl = "",
    popupFileList = [],
    popupSection = "all"
}) => {
    let tabPosition = `mobile`
    return<>
        <div className="h-100- mb-3 div-create-preview" style={{ maxWidth: "55rem", margin: "0px auto" }} >
            {tabPosition == "mobile" ? <div className="row">
                <div className='col-sm-12 col-md-12 col-lg-12'>
                    <div className="w-100 m-auto"
                        style={{ maxWidth: "55rem" }}
                    >
                        <FormsPreviewPhoneTextDragComponentAds
                            data={data ? data : null}
                            fileList={fileList}
                            picUrl={picUrl}
                            isDownloadNo={true}
                            isPrintNo={true}
                            contentDroppableAreaRender={contentDroppableAreaRender}
                            dataObject={dataObject}
                            AdsTab={AdsTab}
                            activeAdSection={activeAdSection}
                            banners={banners}
                            popupPicUrl={popupPicUrl}
                            popupFileList={popupFileList}
                            popupSection={popupSection}
                        />
                    </div>
                </div>
            </div> : ""}
        </div>
    </>
}
export default MobileViewTextDragComponentAds;